export default __webpack_public_path__ + "static/HelveticaNeue-Medium-8499d23eb63b026f4eac34e03645f5eb.woff2";